import {ConstraintDataDto, ConstraintType} from '../../../../../common/apis/datatype/DataTypeConstraintDto';
import {ConstraintDataPlugin} from './ConstraintDataPlugin';
import {CoreDataType} from "../../../../../common/apis/datatype/DataTypeDefinitionDto";
import {IntegerRangeConstraintPlugin} from "./range/IntegerRangeConstraintPlugin";
import {RegExConstraintPlugin} from "./regex/RegExConstraintPlugin";
import {EnumerationConstraintPlugin} from "./enumeration/EnumerationConstraintPlugin";
import {FloatRangeConstraintPlugin} from "./range/FloatRangeConstraintPlugin";
import {CurrencyRangeConstraintPlugin} from "./range/CurrencyRangeConstraintPlugin";
import {DateRangeConstraintPlugin} from "./range/DateRangeConstraintPlugin";
import {TimeRangeConstraintPlugin} from "./range/TimeRangeConstraintPlugin";
import {DateTimeRangeConstraintPlugin} from "./range/DateTimeRangeConstraintPlugin";
import {StringLengthRangeConstraintPlugin} from "./range/StringLengthRangeConstraintPlugin";

export class ConstraintDataPluginRegistry {
    private static readonly plugins: Map<ConstraintType, ConstraintDataPlugin> = new Map();

    static registerPlugin<T extends ConstraintDataDto>(plugin: ConstraintDataPlugin<T>): void {
        this.plugins.set(plugin.type, plugin);
    }

    static getPlugin(type: ConstraintType): ConstraintDataPlugin | undefined {
        return this.plugins.get(type);
    }

    static getAvailablePlugins(): ConstraintDataPlugin[] {
        return Array.from(this.plugins.values());
    }

    static getAvailableTypesByDataType(coreDataType: CoreDataType): ConstraintType[] {
        return Array.from(this.plugins.values())
                .filter((plugin) => plugin.getSupportedDataTypes().includes(coreDataType))
                .map((plugin) => plugin.type);
    }
}

ConstraintDataPluginRegistry.registerPlugin(new EnumerationConstraintPlugin());
ConstraintDataPluginRegistry.registerPlugin(new IntegerRangeConstraintPlugin());
ConstraintDataPluginRegistry.registerPlugin(new FloatRangeConstraintPlugin());
ConstraintDataPluginRegistry.registerPlugin(new RegExConstraintPlugin());
ConstraintDataPluginRegistry.registerPlugin(new TimeRangeConstraintPlugin());
ConstraintDataPluginRegistry.registerPlugin(new CurrencyRangeConstraintPlugin());
ConstraintDataPluginRegistry.registerPlugin(new DateRangeConstraintPlugin());
ConstraintDataPluginRegistry.registerPlugin(new DateTimeRangeConstraintPlugin());
ConstraintDataPluginRegistry.registerPlugin(new StringLengthRangeConstraintPlugin())
